export function marketingSiteUrl(path: string): string {
  return `${import.meta.env.VITE_MARKETING_SITE_URL}${path}`;
}
